<template>
  <div class="page-container">
    <!-- Topbar -->
    <top-bar title="Exports"></top-bar>

    <router-view></router-view>
  </div>
</template>

<script>
import TopBar from '@/components/TopBar.vue';

export default {
  name: 'ExportsData',
  components: {
    TopBar,
  },
};
</script>
